import {
  SET_USER_DATA,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_ERR,
  SHOW_DETAIL,
  GET_ALL_USER_REQUEST,
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_ERR,
  GET_USER_DETAIL_REQUEST,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_ERR,
  GRIDE_TOGGLE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCESS,
  FORGOT_PASSWORD_ERR,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERR,
  VERIFY_USER_REQUEST,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_ERR,
  MODEL_TOGGLE,
  CONTANT_ACTIVE_TAB,
  DRAWER_TOGGLE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERR,
  USER_PROFILE_TOGGLE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_ERR,
  GET_USER_DETAIL_CONTENT_REQUEST,
  GET_USER_DETAIL_CONTENT_SUCCESS,
  GET_USER_DETAIL_CONTENT_ERR,
  GET_SURVERY_USER_LIST_REQUEST,
  GET_SURVERY_USER_LIST_SUCCESS,
  GET_SURVERY_USER_LIST_ERR,
  GET_SURVERY_DETERMINANTS_LIST_REQUEST,
  GET_SURVERY_DETERMINANTS_LIST_SUCCESS,
  GET_SURVERY_DETERMINANTS_LIST_ERR,
  GET_PAYMENT_HISTORY_LIST_REQUEST,
  GET_PAYMENT_HISTORY_LIST_SUCCESS,
  GET_PAYMENT_HISTORY_LIST_ERR,
  SET_SELECTED_SURVEY_DATA,
  GET_ALL_USER_ASSESSMENT_REQUEST,
  GET_ALL_USER_ASSESSMENT_SUCCESS,
  GET_ALL_USER_ASSESSMENT_ERR,
  GET_USER_ASSESSMENT_DETAIL_REQUEST,
  GET_USER__ASSESSMENT_DETAIL_SUCCESS,
  GET_USER_ASSESSMENT_DETAIL_ERR,
  DELETE_USER_ASSESSMENT_REQUEST,
  DELETE_USER_ASSESSMENT_SUCCESS,
  DELETE_USER_ASSESSMENT_ERR,
  GET_QUESTION_LIST_REQUEST,
  GET_QUESTION_LIST_SUCCESS,
  GET_QUESTION_LIST_ERR,
  GET_PROGRAM_LIST_REQUEST,
  GET_PROGRAM_LIST_SUCCESS,
  GET_PROGRAM_LIST_ERR,
  CREATE_PROGRAM_REQUEST,
  CREATE_PROGRAM_SUCCESS,
  CREATE_PROGRAM_ERR,
  UPDATE_PROGRAM_REQUEST,
  UPDATE_PROGRAM_SUCCESS,
  UPDATE_PROGRAM_ERR,
  GET_PROGRAM_DETAILS_REQUEST,
  GET_PROGRAM_DETAILS_SUCCESS,
  GET_PROGRAM_DETAILS_ERR,
  GET_OFFER_MODAL_REQUEST,
  GET_OFFER_MODAL_SUCCESS,
  GET_OFFER_MODAL_ERR,
  SAVE_OFFER_MODAL_REQUEST,
  SAVE_OFFER_MODAL_SUCCESS,
  SAVE_OFFER_MODAL_ERR,
  GET_GUEST_PURCHASE_EMAIL_TEMPLATES_REQUEST,
  GET_GUEST_PURCHASE_EMAIL_TEMPLATES_SUCCESS,
  GET_GUEST_PURCHASE_EMAIL_TEMPLATES_ERR,
  SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_REQUEST,
  SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_SUCCESS,
  SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_ERR,
  GET_EMAIL_TEMPLATES_REQUEST,
  GET_EMAIL_TEMPLATES_SUCCESS,
  GET_EMAIL_TEMPLATES_ERR,
  SAVE_EMAIL_TEMPLATE_REQUEST,
  SAVE_EMAIL_TEMPLATE_SUCCESS,
  SAVE_EMAIL_TEMPLATE_ERR,
  GET_ZOHO_LAB_FORM_CONFIGS_REQUEST,
  GET_ZOHO_LAB_FORM_CONFIGS_SUCCESS,
  GET_ZOHO_LAB_FORM_CONFIGS_ERR,
  SAVE_ZOHO_LAB_FORM_CONFIG_REQUEST,
  SAVE_ZOHO_LAB_FORM_CONFIG_SUCCESS,
  SAVE_ZOHO_LAB_FORM_CONFIG_ERR,
} from "../../constants/ActionTypes";
import { toast } from "react-toastify";
import axios from "axios";
import { api, assesementApi, devapi } from "../../constants/api";

export function setUserData(content) {
  return {
    type: SET_USER_DATA,
    content,
  };
}

export const userProfileModalToggle = (toggle, modelData) => {
  return {
    type: USER_PROFILE_TOGGLE,
    payload: {
      toggle: toggle,
      modelData: modelData,
    },
  };
};

export const showDetail = (toggle) => {
  return {
    type: SHOW_DETAIL,
    payload: toggle,
  };
};

export const contentActiveTab = (name) => {
  return {
    type: CONTANT_ACTIVE_TAB,
    payload: name,
  };
};

export const modelToggle = (toggle, modelName) => {
  return {
    type: MODEL_TOGGLE,
    payload: {
      toggle: toggle,
      modelName: modelName,
    },
  };
};

export const drawerToggle = (data) => {
  return {
    type: DRAWER_TOGGLE,
    payload: data,
  };
};

export const grideListToggle = (data) => {
  return {
    type: GRIDE_TOGGLE,
    payload: data,
  };
};

export function updateUserData(obj) {
  return (dispatch) => {
    dispatch(setUserData(obj));
  };
}

export const userLogin = (name, password, callBackFunction1) => {
  return (dispatch) => {
    dispatch({
      type: LOGIN_REQUEST,
      payload: [],
    });
    return axios
      .post(`${api}/login`, {
        email: name,
        password: password,
        osPlatform: "web",
      })
      .then((res) => {
        if (
          res?.data?.status === "success" &&
          res?.data?.data?.contentUserRole?.OrgRoleID === 2
        ) {
          localStorage.setItem("authToken", res?.data?.data?.token);
          localStorage.setItem("isLogin", true);
          localStorage.setItem("loginUser", JSON.stringify(res?.data?.data));
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
          callBackFunction1();
        } else {
          toast("Something went wrong!");
        }
      })
      .catch((err) => {
        toast(err?.response?.data?.message);
        dispatch({
          type: LOGIN_ERR,
          payload: err,
        });
      });
  };
};

export const sendEmail = (email, userName, closeTostSendEmail, role, handleSendEmailCompletion) => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: SEND_EMAIL_REQUEST,
      payload: {},
    });
    return axios
      .post(
        `${api}/invite_user`,
        {
          fullname: userName,
          email: email,
          roleId: role,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        handleSendEmailCompletion()
        dispatch({
          type: SEND_EMAIL_SUCCESS,
          payload: res,
        });
        if (res.status === 201) {
          closeTostSendEmail();
        }
      })
      .catch((err) => {
        handleSendEmailCompletion()
        if (err.response.status === 404) {
          toast("user already exist!");
        }
        dispatch({
          type: SEND_EMAIL_ERR,
          payload: err,
        });
      });
  };
};

export const getAllUser = () => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_ALL_USER_REQUEST,
      payload: [],
    });
    return axios
      .get(`${api}/get_all_users`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_USER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_ALL_USER_ERR,
          payload: err,
        });
      });
  };
};

export const getUserDetails = (id) => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_USER_DETAIL_CONTENT_REQUEST,
      payload: [],
    });
    return axios
      .get(`${api}/contents/get_content_by_user/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch({
          type: GET_USER_DETAIL_CONTENT_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_USER_DETAIL_CONTENT_ERR,
          payload: err,
        });
      });
  };
};

export const getUser = () => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_USER_REQUEST,
      payload: [],
    });
    return axios
      .get(`${api}/get_my_details`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch({
          type: GET_USER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_USER_ERR,
          payload: err,
        });
      });
  };
};

// export const UpdatePassword = (oldPassword, password, passwordConfirm) => {
//   const token = localStorage.getItem("authToken");
//   return (dispatch) => {
//     dispatch({
//       type: CHANGE_PASSWORD_REQUEST,
//       payload: [],
//     });
//     return axios
//       .post(
//         `${api}/update_admin_password`,
//         {
//           oldPassword: oldPassword,
//           password: password,
//           passwordConfirm: passwordConfirm,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       )
//       .then((res) => {
//         dispatch({
//           type: CHANGE_PASSWORD_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         dispatch({
//           type: CHANGE_PASSWORD_ERR,
//           payload: err,
//         });
//       });
//   };
// };

export const updatePasswordApi = async (payload) => {
  const token = localStorage.getItem("authToken");
  return await axios.post(`${api}/update_admin_password`, payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const updateUserApi = async (payload) => {
  const token = localStorage.getItem("authToken");
  return await axios.post(`${api}/edit_user`, payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const forgotPassword = (email) => {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_REQUEST,
      payload: {},
    });
    return axios
      .put(`${api}/send_otp`, {
        email: email,
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: FORGOT_PASSWORD_SUCESS,
            payload: res.data,
          });
          dispatch(
            setUserData({
              status: "otp",
              email,
              userName: email,
              otp: "",
            })
          );
        }
        return res;
      })
      .catch((err) => {
        dispatch({
          type: FORGOT_PASSWORD_ERR,
          payload: err,
        });
        throw err;
      });
  };
};

export const forgotPasswordSubmitApi = async (payload) => {
  return await axios.post(`${api}/update_forgot_password`, {
    ...payload,
    otp: Number(payload.otp),
  });
};

export const verifyOtpApi = async (payload) => {
  return await axios.post(`${api}/verify_user`, {
    ...payload,
    otp: Number(payload.otp),
  });
};

export const verifyUser = (email, otp) => {
  return (dispatch) => {
    dispatch({
      type: VERIFY_USER_REQUEST,
      payload: {},
    });
    return axios
      .post(`${api}/verify_user`, {
        email,
        otp,
      })
      .then((res) => {
        dispatch({
          type: VERIFY_USER_SUCCESS,
          payload: res.data,
        });
        return res;
      })
      .catch((err) => {
        dispatch({
          type: VERIFY_USER_ERR,
          payload: err,
        });
        throw err;
      });
  };
};

export const userDetail = (id) => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_USER_DETAIL_REQUEST,
      payload: {},
    });
    return axios
      .get(`${api}/get/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch({
          type: GET_USER_DETAIL_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_USER_DETAIL_ERR,
          payload: err,
        });
      });
  };
};

export const deleteUser = (id) => {
  console.log('idssss', id)
  return async (dispatch) => {
    const token = localStorage.getItem("authToken");
    dispatch({
      type: DELETE_USER_REQUEST,
      payload: [],
    });
    return axios
      .post(
        `${api}/delete/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        toast("User deleted successfully");
        dispatch({
          type: DELETE_USER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        toast("Something went wrong");
        dispatch({
          type: DELETE_USER_ERR,
          payload: err,
        });
      });
  };
};

export const getSurveyList = () => {
  const token = localStorage.getItem('userToken');
  return (dispatch) => {
    dispatch({
      type: GET_SURVERY_USER_LIST_REQUEST,
      payload: [],
    });
    return axios
      .post(`${assesementApi}/surveyIdList?role=admin`, {
        userId: localStorage.getItem("userToken"),
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_SURVERY_USER_LIST_SUCCESS,
            payload: res.data.surveyIdList,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_SURVERY_USER_LIST_ERR,
          payload: err,
        });
      });
  };
};

export const getDeterminants = (surveyId) => {
  const token = localStorage.getItem('userToken')
  return (dispatch) => {
    dispatch({
      type: GET_SURVERY_DETERMINANTS_LIST_REQUEST,
      payload: [],
    });
    return axios
      .post(`${assesementApi}/userscore?role=admin`, {
        userId: localStorage.getItem("userToken"),
        surveyId: surveyId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_SURVERY_DETERMINANTS_LIST_SUCCESS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_SURVERY_DETERMINANTS_LIST_ERR,
          payload: err,
        });
      });
  };
};

export const updateSuggestion = (userId, suggestionId) => {
  return (dispatch) => {
    return axios
      .post(`${assesementApi}/updateSuggestionDate?role=admin`, {
        userId: localStorage.getItem("userToken"),
        SuggestionID: suggestionId,
      })
      .then((res) => { })
      .catch((err) => { });
  };
};

export const updateReference = (userId, suggestionId) => {
  return (dispatch) => {
    return axios
      .post(`${assesementApi}/updateReferenceDate?role=admin`, {
        userId: localStorage.getItem("userToken"),
        SuggestionID: suggestionId,
      })
      .then((res) => { })
      .catch((err) => { });
  };
};

export const getPaymentHistory = () => {
  return (dispatch) => {
    dispatch({
      type: GET_PAYMENT_HISTORY_LIST_REQUEST,
      payload: [],
    });
    return axios
      .get(`${assesementApi}/getUsersOrder?role=admin`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_PAYMENT_HISTORY_LIST_SUCCESS,
            payload: res.data?.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_PAYMENT_HISTORY_LIST_ERR,
          payload: err,
        });
      });
  };
};

export const setSelectedSurveyData = (data) => {
  return {
    type: SET_SELECTED_SURVEY_DATA,
    payload: data,
  };
};

export const getAllAssessmentUserList = (query) => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_ALL_USER_ASSESSMENT_REQUEST,
      payload: [],
    });
    return axios
      .get(`${devapi}/users-list-for-admin${query}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_ALL_USER_ASSESSMENT_SUCCESS,
            payload: res.data?.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_ALL_USER_ASSESSMENT_ERR,
          payload: err,
        });
      });
  };
};

export const getAssessmentUserDetails = (id) => {
  const token = localStorage.getItem("authToken");
  return (dispatch) => {
    dispatch({
      type: GET_USER_ASSESSMENT_DETAIL_REQUEST,
      payload: [],
    });
    return axios
      .get(`${devapi}/getUserByIDForAdmin/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_USER__ASSESSMENT_DETAIL_SUCCESS,
            payload: res.data?.data,
          });
          if (res.data?.data && res.data?.data?.userToken) {
            localStorage.setItem("userToken", res.data?.data?.userToken);
          }
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_USER_ASSESSMENT_DETAIL_ERR,
          payload: err,
        });
      });
  };
};

export const deleteAssessmentUser = () => {
  return (dispatch) => {
    dispatch({
      type: DELETE_USER_ASSESSMENT_REQUEST,
      payload: {},
    });
    return axios
      .put(
        `${devapi}/deleteUser`,
        {
          UserID: localStorage.getItem("userToken")
        },
        // {
        //   headers: {
        //     Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        //   },
        // }
      )
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: DELETE_USER_ASSESSMENT_SUCCESS,
            payload: res.data,
          });
        }
        return res;
      })
      .catch((err) => {
        dispatch({
          type: DELETE_USER_ASSESSMENT_ERR,
          payload: err,
        });
        throw err
      });
  };
};

export const getQuestionList = (surveyId) => {
  const token = localStorage.getItem('userToken')
  return (dispatch) => {
    dispatch({
      type: GET_QUESTION_LIST_REQUEST,
      payload: [],
    });
    return axios
      .post(`${assesementApi}/question?role=admin`, {
        userId: localStorage.getItem("userToken"),
        surveyId: surveyId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_QUESTION_LIST_SUCCESS,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_QUESTION_LIST_ERR,
          payload: err,
        });
      });
  };
};

export const getProgramList = (query) => {
  return (dispatch) => {
    dispatch({
      type: GET_PROGRAM_LIST_REQUEST,
      payload: {},
    });
    return axios
      .get(`${devapi}/get-program-subscription-list${query ? `${query}` : ''}`)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_PROGRAM_LIST_SUCCESS,
            payload: res.data.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_PROGRAM_LIST_ERR,
          payload: err,
        });
      });
  };
};

export const createProgram = (data) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_PROGRAM_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/save-programs-subscriptions`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: CREATE_PROGRAM_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: CREATE_PROGRAM_ERR,
          payload: err,
        });
        return err;
      });
  };
};

export const deleteProgram = (id) =>
  axios.delete(`${devapi}/delete-program-subscription/${id}`);

export const updateProgram = (data) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROGRAM_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/update-program-subscription`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: UPDATE_PROGRAM_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_PROGRAM_ERR,
          payload: err,
        });
        return err
      });
  };
};

export const getSiteSettingsApi = async () => {
  const res = await axios.get(`${devapi}/site-settings`);
  return res?.data;
};

export const updateSiteSettingsApi = async (payload) => {
  const res = await axios.post(`${devapi}/site-settings`, payload);
  return res?.data;
};

export const getProgramDetails = (id) => {
  return (dispatch) => {
    dispatch({
      type: GET_PROGRAM_DETAILS_REQUEST,
      payload: [],
    });
    return axios
      .get(`${devapi}/get-program-subscription/${id}`)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: GET_PROGRAM_DETAILS_SUCCESS,
            payload: res.data.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_PROGRAM_DETAILS_ERR,
          payload: err,
        });
      });
  };
};

export const uploadFile = (data) => {
  return (dispatch) => {
    return axios
      .post(`${devapi}/upload`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        }
      })
      .catch((err) => {
        return err;
      });
  };
};

export const exportUserData = async (query) => {
  return await axios.get(`${devapi}/export-csv${query ? `${query}` : ''}`, {
    responseType: 'blob',
  });
};

export const getFinancialReports = async (query) => {
  return await axios.get(`${devapi}/generate-reports${query ? `${query}` : ''}`);
};

export const exportFinancialReportsData = async (query = '', format = 'excel') => {
  const url = `${devapi}/export-pdf${query ? `${query}&format=${format}` : `?format=${format}`}`;
  return await axios.get(url, {
    responseType: 'blob',
  });
};

const couponReportAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
});

export const getCouponUsageReport = async (query) => {
  return await axios.get(
    `${devapi}/admin/coupon-usage-report${query || ''}`,
    couponReportAuthHeaders()
  );
};

export const getCouponUsageFilterOptions = async () => {
  return await axios.get(
    `${devapi}/admin/coupon-usage-report/filter-options`,
    couponReportAuthHeaders()
  );
};

export const exportCouponUsageReportCsv = async (query) => {
  return await axios.get(
    `${devapi}/admin/coupon-usage-report/export-csv${query || ''}`,
    {
      ...couponReportAuthHeaders(),
      responseType: 'blob',
    }
  );
};

export const getOfferModal = () => {
  return (dispatch) => {
    dispatch({
      type: GET_OFFER_MODAL_REQUEST,
      payload: {},
    });
    return axios
      .get(`${devapi}/offer-modal`)
      .then((res) => {
        if (res.status === 200) {
          const payload = res.data?.data ?? null;
          dispatch({
            type: GET_OFFER_MODAL_SUCCESS,
            payload,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_OFFER_MODAL_ERR,
          payload: err,
        });
      });
  };
};

export const saveOfferModal = (data) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_OFFER_MODAL_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/offer-modal`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: SAVE_OFFER_MODAL_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: SAVE_OFFER_MODAL_ERR,
          payload: err,
        });
        return err;
      });
  };
};

export const updateOfferModal = (data) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_OFFER_MODAL_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/offer-modal/update`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: SAVE_OFFER_MODAL_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: SAVE_OFFER_MODAL_ERR,
          payload: err,
        });
        return err;
      });
  };
};

const normalizeGuestPurchaseEmailTemplatesPayload = (raw) => {
  const payload = { program: null, subscription: null, mergeTags: [] };
  if (!raw) return payload;

  const tagRows = raw.merge_tags ?? raw.mergeTags;
  if (Array.isArray(tagRows)) {
    payload.mergeTags = tagRows
      .map((row) => {
        if (!row || typeof row !== "object") return null;
        const tag = String(row.tag ?? row.name ?? "").trim();
        if (!tag) return null;
        return {
          tag,
          description: String(row.description ?? row.desc ?? "").trim(),
        };
      })
      .filter(Boolean);
  }

  if (raw.program != null || raw.subscription != null) {
    payload.program = raw.program ?? null;
    payload.subscription = raw.subscription ?? null;
    return payload;
  }
  if (Array.isArray(raw)) {
    raw.forEach((row) => {
      const t = row.template_type ?? row.templateType;
      if (t === "program") payload.program = row;
      if (t === "subscription") payload.subscription = row;
    });
    return payload;
  }
  return payload;
};

export const getGuestPurchaseEmailTemplates = () => {
  return (dispatch) => {
    dispatch({
      type: GET_GUEST_PURCHASE_EMAIL_TEMPLATES_REQUEST,
      payload: {},
    });
    return axios
      .get(`${devapi}/guest-purchase-email-templates`)
      .then((res) => {
        if (res.status === 200) {
          const raw = res.data?.data ?? res.data ?? null;
          const payload = normalizeGuestPurchaseEmailTemplatesPayload(raw);
          dispatch({
            type: GET_GUEST_PURCHASE_EMAIL_TEMPLATES_SUCCESS,
            payload,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_GUEST_PURCHASE_EMAIL_TEMPLATES_ERR,
          payload: err,
        });
      });
  };
};

export const saveGuestPurchaseEmailTemplate = (data) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/guest-purchase-email-templates`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_ERR,
          payload: err,
        });
        return err;
      });
  };
};

export const updateGuestPurchaseEmailTemplate = (data) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_REQUEST,
      payload: [],
    });
    return axios
      .post(`${devapi}/guest-purchase-email-templates/update`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_SUCCESS,
          });
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type: SAVE_GUEST_PURCHASE_EMAIL_TEMPLATE_ERR,
          payload: err,
        });
        return err;
      });
  };
};

const normalizeEmailTemplatesPayload = (raw) => {
  const payload = { templates: [], globalMergeTags: [] };
  if (!raw) return payload;

  const tagRows = raw.global_merge_tags ?? raw.globalMergeTags;
  if (Array.isArray(tagRows)) {
    payload.globalMergeTags = tagRows
      .map((row) => {
        if (!row || typeof row !== "object") return null;
        const tag = String(row.tag ?? row.name ?? "").trim();
        if (!tag) return null;
        return { tag, description: String(row.description ?? "").trim() };
      })
      .filter(Boolean);
  }

  const rows = raw.templates ?? (Array.isArray(raw) ? raw : []);
  if (Array.isArray(rows)) {
    payload.templates = rows.map((r) => ({
      id: r.id ?? null,
      emailKey: r.email_key ?? r.emailKey ?? "",
      name: r.name ?? "",
      description: r.description ?? "",
      emailSubject: r.email_subject ?? r.emailSubject ?? "",
      bodyHtml: r.body_html ?? r.bodyHtml ?? "",
      isActive:
        r.is_active === undefined || r.is_active === null
          ? true
          : String(r.is_active) === "1" || r.is_active === true,
      mergeTags: Array.isArray(r.merge_tags ?? r.mergeTags)
        ? (r.merge_tags ?? r.mergeTags).map((t) => ({
            tag: String(t.tag ?? t.name ?? "").trim(),
            description: String(t.description ?? "").trim(),
          }))
        : [],
      source: r.source ?? "default",
    }));
  }
  return payload;
};

export const getEmailTemplates = () => {
  return (dispatch) => {
    dispatch({ type: GET_EMAIL_TEMPLATES_REQUEST, payload: {} });
    return axios
      .get(`${devapi}/email-templates`)
      .then((res) => {
        if (res.status === 200) {
          const raw = res.data?.data ?? res.data ?? null;
          dispatch({
            type: GET_EMAIL_TEMPLATES_SUCCESS,
            payload: normalizeEmailTemplatesPayload(raw),
          });
        }
      })
      .catch((err) => {
        dispatch({ type: GET_EMAIL_TEMPLATES_ERR, payload: err });
      });
  };
};

export const saveEmailTemplate = (data) => {
  return (dispatch) => {
    dispatch({ type: SAVE_EMAIL_TEMPLATE_REQUEST, payload: [] });
    return axios
      .post(`${devapi}/email-templates/save`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: SAVE_EMAIL_TEMPLATE_SUCCESS });
          return res;
        }
      })
      .catch((err) => {
        dispatch({ type: SAVE_EMAIL_TEMPLATE_ERR, payload: err });
        return err;
      });
  };
};

export const updateEmailTemplate = (data) => {
  return (dispatch) => {
    dispatch({ type: SAVE_EMAIL_TEMPLATE_REQUEST, payload: [] });
    return axios
      .post(`${devapi}/email-templates/update`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Custom-Header": "CustomValue",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: SAVE_EMAIL_TEMPLATE_SUCCESS });
          return res;
        }
      })
      .catch((err) => {
        dispatch({ type: SAVE_EMAIL_TEMPLATE_ERR, payload: err });
        return err;
      });
  };
};

export const testSendEmailTemplate = (payload) => {
  return () => {
    return axios
      .post(`${devapi}/email-templates/test-send`, payload, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => res)
      .catch((err) => err);
  };
};

const zohoLabFormAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    "Content-Type": "application/json",
  },
});

export const getZohoLabFormConfigs = () => {
  return (dispatch) => {
    dispatch({ type: GET_ZOHO_LAB_FORM_CONFIGS_REQUEST, payload: [] });
    return axios
      .get(`${devapi}/zoho-lab-form-configs`, zohoLabFormAuthHeaders())
      .then((res) => {
        dispatch({
          type: GET_ZOHO_LAB_FORM_CONFIGS_SUCCESS,
          payload: res.data?.data ?? [],
        });
        return res;
      })
      .catch((err) => {
        dispatch({ type: GET_ZOHO_LAB_FORM_CONFIGS_ERR, payload: err });
        return err;
      });
  };
};

export const createZohoLabFormConfig = (payload) => {
  return (dispatch) => {
    dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_REQUEST, payload: [] });
    return axios
      .post(`${devapi}/zoho-lab-form-configs`, payload, zohoLabFormAuthHeaders())
      .then((res) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_SUCCESS });
        return res;
      })
      .catch((err) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_ERR, payload: err });
        throw err;
      });
  };
};

export const updateZohoLabFormConfig = (payload) => {
  return (dispatch) => {
    dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_REQUEST, payload: [] });
    return axios
      .post(
        `${devapi}/zoho-lab-form-configs/update`,
        payload,
        zohoLabFormAuthHeaders()
      )
      .then((res) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_SUCCESS });
        return res;
      })
      .catch((err) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_ERR, payload: err });
        throw err;
      });
  };
};

export const deleteZohoLabFormConfig = (id) => {
  return (dispatch) => {
    dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_REQUEST, payload: [] });
    return axios
      .delete(
        `${devapi}/zoho-lab-form-configs/${id}`,
        zohoLabFormAuthHeaders()
      )
      .then((res) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_SUCCESS });
        return res;
      })
      .catch((err) => {
        dispatch({ type: SAVE_ZOHO_LAB_FORM_CONFIG_ERR, payload: err });
        throw err;
      });
  };
};

const membershipFeatureAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    "Content-Type": "application/json",
  },
});

/** Admin: load membership feature catalogue (portal menu options). */
export const getMembershipFeatureCatalogue = () => {
  return () =>
    axios
      .get(
        `${devapi}/membership-features/catalogue`,
        membershipFeatureAuthHeaders()
      )
      .then((res) => {
        const data = res.data?.data ?? res.data;
        return Array.isArray(data) ? data : [];
      })
      .catch((err) => {
        throw err;
      });
};

/** Admin: load membership feature toggles for a program/subscription. */
export const getMembershipFeatures = (programId) => {
  return () =>
    axios
      .get(
        `${devapi}/membership-features/${programId}`,
        membershipFeatureAuthHeaders()
      )
      .then((res) => res.data?.data ?? res.data)
      .catch((err) => {
        throw err;
      });
};

/** Admin: save membership feature toggles for a program/subscription. */
export const updateMembershipFeatures = (programId, features) => {
  return () =>
    axios
      .put(
        `${devapi}/membership-features/${programId}`,
        { features },
        membershipFeatureAuthHeaders()
      )
      .then((res) => res.data?.data ?? res.data)
      .catch((err) => {
        throw err;
      });
};

/** Admin: load Free Plan (non-member) portal feature toggles. */
export const getFreePlanFeaturesApi = () =>
  axios
    .get(
      `${devapi}/membership-features/free-plan`,
      membershipFeatureAuthHeaders()
    )
    .then((res) => res.data?.data ?? res.data);

/** Admin: save Free Plan (non-member) portal feature toggles. */
export const updateFreePlanFeaturesApi = (features) =>
  axios
    .put(
      `${devapi}/membership-features/free-plan`,
      { features },
      membershipFeatureAuthHeaders()
    )
    .then((res) => res.data?.data ?? res.data);
